// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#certificate-uploader-dialog-container > .dialogBlock {
    width: 600px;
}

.certificate-uploader-dialog .theia-select {
    border: none !important;
}
.certificate-uploader-dialog .arduino-select__control {
    height: 31px;
    background: var(--theia-dropdown-background) !important;
}

.certificate-uploader-dialog .dialogRow > button {
    margin-right: 3px;
}

.certificate-uploader-dialog .certificate-list {
    border: 1px solid var(--theia-editorWidget-border);
    border-radius: 2px;
    color: var(--theia-editor-foreground);
    background-color: var(--theia-editor-background);
    overflow: auto;
    height: 120px;
    flex: 1;
}
.certificate-uploader-dialog .certificate-list .certificate-row {
    display: flex;
    padding: 6px 10px 5px 10px;
}
.certificate-uploader-dialog .certificate-list .certificate-row:hover {
    background-color: var(--theia-list-activeSelectionBackground);
}

.certificate-uploader-dialog .upload-status {
    display: flex;
    align-items: center;
    flex: 1;
}
.certificate-uploader-dialog .success {
    display: flex;
    align-items: center;
    color: #1da086;
}

.certificate-uploader-dialog .warn {
    color: #c11f09;
}

.certificate-uploader-dialog .status-icon {
    margin-right: 10px;
}

.certificate-uploader-dialog .add-cert-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.certificate-uploader-dialog .add-cert-btn .caret {
    margin-left: 6px;
}

.certificate-add {
    padding: 16px;
    border-radius: 3px;
    border: 1px solid var(--theia-editorWidget-border);
    color: var(--theia-editorWidget-foreground);
    background-color: var(--theia-editorWidget-background);
}

.certificate-add input {
    margin-top: 12px;
    padding: 0 12px;
    width: 100%;
    box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/certificate-uploader-dialog.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,uDAAuD;AAC3D;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,qCAAqC;IACrC,gDAAgD;IAChD,cAAc;IACd,aAAa;IACb,OAAO;AACX;AACA;IACI,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,6DAA6D;AACjE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,OAAO;AACX;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,2CAA2C;IAC3C,sDAAsD;AAC1D;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B","sourcesContent":["#certificate-uploader-dialog-container > .dialogBlock {\r\n    width: 600px;\r\n}\r\n\r\n.certificate-uploader-dialog .theia-select {\r\n    border: none !important;\r\n}\r\n.certificate-uploader-dialog .arduino-select__control {\r\n    height: 31px;\r\n    background: var(--theia-dropdown-background) !important;\r\n}\r\n\r\n.certificate-uploader-dialog .dialogRow > button {\r\n    margin-right: 3px;\r\n}\r\n\r\n.certificate-uploader-dialog .certificate-list {\r\n    border: 1px solid var(--theia-editorWidget-border);\r\n    border-radius: 2px;\r\n    color: var(--theia-editor-foreground);\r\n    background-color: var(--theia-editor-background);\r\n    overflow: auto;\r\n    height: 120px;\r\n    flex: 1;\r\n}\r\n.certificate-uploader-dialog .certificate-list .certificate-row {\r\n    display: flex;\r\n    padding: 6px 10px 5px 10px;\r\n}\r\n.certificate-uploader-dialog .certificate-list .certificate-row:hover {\r\n    background-color: var(--theia-list-activeSelectionBackground);\r\n}\r\n\r\n.certificate-uploader-dialog .upload-status {\r\n    display: flex;\r\n    align-items: center;\r\n    flex: 1;\r\n}\r\n.certificate-uploader-dialog .success {\r\n    display: flex;\r\n    align-items: center;\r\n    color: #1da086;\r\n}\r\n\r\n.certificate-uploader-dialog .warn {\r\n    color: #c11f09;\r\n}\r\n\r\n.certificate-uploader-dialog .status-icon {\r\n    margin-right: 10px;\r\n}\r\n\r\n.certificate-uploader-dialog .add-cert-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.certificate-uploader-dialog .add-cert-btn .caret {\r\n    margin-left: 6px;\r\n}\r\n\r\n.certificate-add {\r\n    padding: 16px;\r\n    border-radius: 3px;\r\n    border: 1px solid var(--theia-editorWidget-border);\r\n    color: var(--theia-editorWidget-foreground);\r\n    background-color: var(--theia-editorWidget-background);\r\n}\r\n\r\n.certificate-add input {\r\n    margin-top: 12px;\r\n    padding: 0 12px;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
